import { createServerFn } from "@tanstack/react-start";
import { AwsClient } from "aws4fetch";

interface PresignedUploadInput {
  ext: string;
}

async function generatePresignedUrl(prefix: string, ext: string) {
  if (!ext || typeof ext !== "string") {
    throw new Error("Missing or invalid file extension");
  }

  const key = `${prefix}/${crypto.randomUUID()}.${ext}`;

  const client = new AwsClient({
    accessKeyId: process.env.AWS_S3_ACCESS_KEY_ID || "",
    secretAccessKey: process.env.AWS_S3_SECRET_ACCESS_KEY || "",
  });

  const endpoint = new URL(
    `https://${process.env.AWS_S3_BUCKET}.s3.${process.env.AWS_S3_REGION}.amazonaws.com/${key}`
  );
  endpoint.searchParams.set("X-Amz-Expires", "3600");

  const signed = await client.sign(endpoint, {
    aws: { signQuery: true },
    method: "PUT",
  });

  return { key, url: signed.url.toString() };
}

export const createUserAvatarUploadUrl = createServerFn({ method: "POST" })
  .inputValidator((data: PresignedUploadInput) => data)
  .handler(({ data }) => {
    return generatePresignedUrl("u", data.ext);
  });

export const createExperiencePhotoUploadUrl = createServerFn({ method: "POST" })
  .inputValidator((data: PresignedUploadInput) => data)
  .handler(({ data }) => {
    return generatePresignedUrl("e", data.ext);
  });
